import { ThreeEvent } from '@react-three/fiber';
import React, { useEffect, useState } from 'react';
import { Vector3 } from 'three';

const DOCK_DEFAULT_SIZE = 1.0;
const DOCK_HOVER_SIZE = 1.1;

export const DockingPointMesh = ({
  position,
  onClick,
}: {
  position: Vector3;
  onClick: (e: ThreeEvent<PointerEvent>) => void;
}) => {
  const [hovered, setHovered] = useState(false);
  const size = hovered ? DOCK_HOVER_SIZE : DOCK_DEFAULT_SIZE;

  const resetCursor = () => {
    document.body.style.cursor = 'auto';
  };

  useEffect(() => {
    return () => {
      resetCursor();
    };
  }, []);

  return (
    <group
      position={[position.x, position.y, 0]}
      renderOrder={9999}
      onPointerOver={(e) => {
        e.stopPropagation();
        setHovered(true);
        document.body.style.cursor = 'pointer';
      }}
      onPointerOut={(e) => {
        e.stopPropagation();
        setHovered(false);
        resetCursor();
      }}
      onPointerDown={(e) => {
        e.stopPropagation();
        setHovered(false);
        resetCursor();
        onClick(e);
      }}
      onPointerUp={() => {
        setHovered(false);
        resetCursor();
      }}
      onPointerCancel={() => {
        setHovered(false);
        resetCursor();
      }}
    >
      <mesh renderOrder={9998} position={[0, 0, 5]}>
        <circleGeometry args={[size + 0.15, 32]} />
        <meshBasicMaterial color="#FFFFFF" depthTest={false} transparent />
      </mesh>

      <mesh renderOrder={9999} position={[0, 0, 5.01]}>
        <circleGeometry args={[size, 32]} />
        <meshBasicMaterial color={hovered ? '#41C0F0' : '#009FE3'} depthTest={false} transparent />
      </mesh>
    </group>
  );
};